var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49506 3.8C6.44489 4.30533 6.01853 4.7 5.5 4.7C4.98147 4.7 4.55511 4.30533 4.50494 3.8H2V5.4H18V3.8H16.3951C16.3449 4.30533 15.9185 4.7 15.4 4.7C14.8815 4.7 14.4551 4.30533 14.4049 3.8H6.49506ZM4.5 1.8V1C4.5 0.447715 4.94772 0 5.5 0C6.05228 0 6.5 0.447715 6.5 1V1.8H14.4V1C14.4 0.447715 14.8477 0 15.4 0C15.9523 0 16.4 0.447715 16.4 1V1.8H18.1C19.1493 1.8 20 2.65066 20 3.7V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V3.7C0 2.65066 0.850659 1.8 1.9 1.8H4.5ZM18 7.4H2V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V7.4ZM4.6 11C4.04772 11 3.6 10.5523 3.6 10C3.6 9.44771 4.04772 9 4.6 9H8.2C8.75229 9 9.2 9.44771 9.2 10C9.2 10.5523 8.75229 11 8.2 11H4.6ZM4.6 14.6C4.04772 14.6 3.6 14.1523 3.6 13.6C3.6 13.0477 4.04772 12.6 4.6 12.6H11.8C12.3523 12.6 12.8 13.0477 12.8 13.6C12.8 14.1523 12.3523 14.6 11.8 14.6H4.6Z",
    fill: "#92929D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.fb00d20c852b68bf10cfa7f299f40fe9.svg";
export { ForwardRef as ReactComponent };